import Logo from "./Logo/logo.png";
import MainLogo from "./Logo/mainLogo.png";

import SearchIcon from "./Icons/search.svg";
import ClockIcon from "./Icons/clock.svg";
import EyeIcon from "./Icons/eyeIcon.svg";
import VerifiedIcon from "./Icons/verified.svg";
import ListYellowBulletIcon from "./Icons/yellowArrow.svg";
import CrossIcon from "./Icons/cross.svg";
import CameraIcon from "./Icons/camera.svg";
import ClearFilterIcon from "./Icons/clearFilter.svg";
import DownArrow from "./Icons/downArrow.svg";
import FeturedStar from "./Icons/feturedStar.png";
import Profile from "./Icons/Profile.png";

/* -------------------------------------------------------------------------- */
/*                                Image                                */
/* -------------------------------------------------------------------------- */

import RankingImage from "./Images/homePageV2/ranking-image.png";
import FindCollegeImage from "./Images/homePageV2/find-college.png";
import CollegePredictorImage from "./Images/homePageV2/college-predictor-image.png";
import CompareCollegeImage from "./Images/homePageV2/compare-college-image.png";
import StudyAbroadImage from "./Images/homePageV2/study-abroad.jpeg";
import ExamsImage from "./Images/homePageV2/exams.png";
import StudyAbroadGradientImage from "./Images/study-abroad/study-abroad-bg-gradient.png";
import ModalBgImage from "./Images/Modal/bg-modal-image.jpg";
import CollegeHaiCity from "./Images/homePageV2/collegehai-dummy.webp";
import AboutUsBgImage from "./Images/AboutUs/about-us-bg-image.png";
import AboutUsImage1 from "./Images/AboutUs/about-us-image-1.png";
import AboutUsImage2 from "./Images/AboutUs/about-us-image-2.png";
import AboutUsImage3 from "./Images/AboutUs/about-us-image-3.png";
import AboutUsStudentIcon from "./Images/AboutUs/noto_man-student-light-skin-tone.png";
import AboutUsBuildingIcon from "./Images/AboutUs/emojione_classical-building.png";
import ProfileImage from "./Images/profile.png";
import CompareBannerImage from "./Images/compare-banner.png";
import CollegeHaiBannerImage from "./Images/NewsPage/collegeHaiBanner.webp";
/* -------------------------------------------------------------------------- */
/*                                    Logo                                    */
/* -------------------------------------------------------------------------- */

import LogoV2 from "./Logo/college-hai-no-bg-logo.png";
import CollegeHaiWhiteBgLogo from "./Logo/college-hai-white-bg-logo.jpg";
import CollegeHaiWhiteLogo from "./Logo/college-hai-white-logo.png";

/* -------------------------------------------------------------------------- */
/*                                    Icon                                    */
/* -------------------------------------------------------------------------- */

import CollegeLogoV2 from "./Icons/Navbar/collegeIcon.png";
import ExamLogoV2 from "./Icons/Navbar/examIcon.png";
import CourseLogoV2 from "./Icons/Navbar/courseIcon.png";
import ScholarshipLogoV2 from "./Icons/Navbar/scholarship_icon.png";
import StudyAbroadLogoV2 from "./Icons/Navbar/studyAbroadIcon.png";
import NewsLogoV2 from "./Icons/Navbar/newsIcon.png";
import BlogsLogoV2 from "./Icons/Navbar/blogIcon.png";
import MoreLogoV2 from "./Icons/Navbar/moreIcon.svg";
import InstituteIcon from "./Icons/Navbar/institute-icon.png";
import ArticleIcon from "./Icons/Navbar/articleIcon.png";
import CrossBlackIcon from "./Icons/common/cross-black-icon.svg";
import RightArrowBlackIcon from "./Icons/common/right-arrow-black.svg";
import AdmissionIcon from "./Icons/Modal/admission-icon.png";
import PlacementIcon from "./Icons/Modal/placement.png";
import ReviewsIcon from "./Icons/Modal/review.png";
import EducationLoadIcon from "./Icons/Modal/education-loan.png";
import ScholarshipIcon from "./Icons/Modal/scholarship.png";
import CollegePredictorIcon from "./Icons/Modal/college-predictor.png";
import RightGreenCheck from "./Icons/common/right-check-green-tick.svg";
import ArticleIconDestination from "./Icons/Study-Abroad/articlesIcon.png";
import BlogIconDestination from "./Icons/Study-Abroad/blogsIcon.png";
import After10th from "./Icons/Course/after-10th.png";
import After12th from "./Icons/Course/after-12th.png";
import Certification from "./Icons/Course/certification.png";
import Diploma from "./Icons/Course/diploma.png";
import Masters from "./Icons/Course/masters.png";
import Phd from "./Icons/Course/phd.png";
import ApplyNowArrow from "./Icons/apply_now_arrow.png";
import DownloadIcon from "./Icons/download_icon.png";

/* -------------------------------------------------------------------------- */
/*                                   Banner                                   */
/* -------------------------------------------------------------------------- */
import CourseHomepageBannerImage from "./Banners/course-home-page-banner.png";
import IITDelhiIBanner from "./Images/homePageV2/Banner/IIT Delhi.webp";

import StudyAbroadBanner4 from "./Images/study-abroad/Banner/Massachusetts Institute of Technology (MIT).jpg";
import WorldMapBanner from "./Banners/mapbg.png";
import StudyAbroadBanner from "./Banners/bg-study-abroad.png";
import FormSubmissionBanner from "./Images/Modal/form-submission.jpg";

/* -------------------------------------------------------------------------- */
/*                                  SVG ICON                                  */
/* -------------------------------------------------------------------------- */

import GraduateSvg from "./Icons/common/graduate-icon.svg";
import MailSvg from "./Icons/common/mail-icon.svg";
import LocationSvg from "./Icons/common/location-icon.svg";
import PhoneSvg from "./Icons/common/phone-icon.svg";
import UserSvg from "./Icons/common/user-icon.svg";
import GlobeSvg from "./Icons/common/globe-icon.svg";
import CalendarSvg from "./Icons/common/calendar-icon.svg";
import FbSvg from "./Icons/common/fb-icon.svg";
import TwitterSvg from "./Icons/common/twitter-con.svg";
import InstagramSvg from "./Icons/common/instagram-icon.svg";
import LinkedinSvg from "./Icons/common/linkedin-icon.svg";
import YoutubeSvg from "./Icons/common/youtube-icon.svg";
import SearchSvg from "./Icons/common/search-icon.svg";
import ChevrondownSvg from "./Icons/common/chevron-right-icon.svg";
import CompareSvg from "./Icons/common/compare-icon.svg";
import NineDotsSvg from "./Icons/common/nine-black-dots.svg";
import HamburgerSvg from "./Icons/common/hamburger-icon.svg";
import YoutubeColorSvg from "./Icons/common/youtube-color-icon.svg";
import WhatsAppSvg from "./Icons/common/whatsapp-icon.svg";
import FilterBy from "./Icons/common/filter-by.png";
import GoogleColorIcon from "./Icons/common/google-color-icon.svg";
import CallIcon from "./Icons/common/call-icon.svg";
import DownloadIconSvg from "./Icons/common/download.svg";
import WebsiteLinkIcon from "./Icons/common/website-link-icon.svg";
import HomeFilledIcon from "./Icons/common/home-white-icon.svg";
import SamplePaper from "./Icons/Boards/sample-paper.svg";
import FreeCounselling from "./Icons/Boards/free-counselling.svg";
import CalendarFillIcon from "./Icons/common/calendar-fill-icon.svg";
import EyeFillIcon from "./Icons/common/eye-fill-icon.svg";
import RightArrowFillIcon from "./Icons/common/right-arrow-fill-white.svg";

/* -------------------------------------------------------------------------- */
/*                                   Vector                                   */
/* -------------------------------------------------------------------------- */

import ConfusedAboutVector from "./Images/banners/confused-about-vector.jpg";

/* -------------------------------------------------------------------------- */
/*                                   Lottie                                   */
/* -------------------------------------------------------------------------- */
// import SuccessFormAnimation from "./Lottie/SuccessForm.json";

export {
  Profile,
  Logo,
  MainLogo,
  FeturedStar,
  DownArrow,
  SearchIcon,
  ClearFilterIcon,
  CrossIcon,
  ListYellowBulletIcon,
  ClockIcon,
  CameraIcon,
  VerifiedIcon,
  EyeIcon,
  LogoV2,
  CollegeLogoV2,
  ExamLogoV2,
  CourseLogoV2,
  ScholarshipLogoV2,
  StudyAbroadLogoV2,
  NewsLogoV2,
  BlogsLogoV2,
  MoreLogoV2,
  IITDelhiIBanner,
  CrossBlackIcon,
  RightArrowBlackIcon,
  RankingImage,
  FindCollegeImage,
  CollegePredictorImage,
  CompareCollegeImage,
  StudyAbroadImage,
  ExamsImage,
  StudyAbroadGradientImage,
  AdmissionIcon,
  PlacementIcon,
  ReviewsIcon,
  EducationLoadIcon,
  ScholarshipIcon,
  CollegePredictorIcon,
  CollegeHaiWhiteBgLogo,
  ModalBgImage,
  CollegeHaiWhiteLogo,
  RightGreenCheck,
  ArticleIconDestination,
  BlogIconDestination,
  CourseHomepageBannerImage,
  After10th,
  After12th,
  Certification,
  Diploma,
  Masters,
  Phd,
  // SuccessFormAnimation,
  CollegeHaiCity,
  SamplePaper,
  FreeCounselling,
  StudyAbroadBanner4,
  ArticleIcon,
  AboutUsBgImage,
  AboutUsImage1,
  AboutUsImage2,
  AboutUsImage3,
  AboutUsStudentIcon,
  AboutUsBuildingIcon,
  WorldMapBanner,
  GraduateSvg,
  MailSvg,
  LocationSvg,
  PhoneSvg,
  UserSvg,
  GlobeSvg,
  CalendarSvg,
  FbSvg,
  TwitterSvg,
  InstagramSvg,
  LinkedinSvg,
  YoutubeSvg,
  SearchSvg,
  ChevrondownSvg,
  CompareSvg,
  NineDotsSvg,
  WhatsAppSvg,
  HamburgerSvg,
  YoutubeColorSvg,
  ApplyNowArrow,
  DownloadIcon,
  StudyAbroadBanner,
  ProfileImage,
  CompareBannerImage,
  FilterBy,
  GoogleColorIcon,
  CallIcon,
  InstituteIcon,
  DownloadIconSvg,
  WebsiteLinkIcon,
  CollegeHaiBannerImage,
  HomeFilledIcon,
  CalendarFillIcon,
  EyeFillIcon,
  RightArrowFillIcon,
  ConfusedAboutVector,
  FormSubmissionBanner,
};
